import React from "react";

type PortfolioContextType = {};

const defaultValue: PortfolioContextType = {};

export const PortfolioContext = React.createContext(defaultValue);

export default function PortfolioContextProvider(props: {
  children: React.ReactNode;
}) {
  return (
    <PortfolioContext.Provider value={{}}>
      {props.children}
    </PortfolioContext.Provider>
  );
}
